
import Vue from "vue";
import Alerter from "@/components/Alerter.vue";
import { Alert } from "@/commons/types";
import { UserSchema, UsersService } from "@/commons/client";

export default Vue.extend({
  name: "UserListView",

  components: {
    Alerter,
  },

  data: () => ({
    alerts: [] as Alert[],
    users: [] as UserSchema[],
    searchKey: "",
    loading: false,
    headers: [
      { text: "Username", value: "username" },
      { text: "Email", value: "email" },
      { text: "Nome completo", value: "full_name", sortable: false },
      { text: "Creato il", value: "created" },
      { text: "Stato", value: "status", sortable: false },
      { text: "Azioni", value: "actions", sortable: false },
    ],
  }),

  computed: {
    filteredUsers(): UserSchema[] {
      const key = this.searchKey.toLowerCase();
      return this.users.filter(
        (u) =>
          u.username?.toLowerCase().includes(key) ||
          u.email?.toLowerCase().includes(key)
      );
    },
  },

  methods: {
    async getUsers(search?: string): Promise<void> {
      this.loading = true;
      try {
        const result = await UsersService.userListV1UsersGet(
          undefined,
          undefined,
          search
        );
        this.users = result;
      } catch (error) {
        this.alerts.push({
          type: "error",
          text: "Errore nel recupero degli utenti",
        });
      } finally {
        this.loading = false;
      }
    },

    async search(): Promise<void> {
      await this.getUsers(this.searchKey);
    },

    formatDateTime(dateStr: string): string {
      return new Date(dateStr).toLocaleString("it-IT", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
  },

  async mounted() {
    await this.getUsers();
  },
});
